import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  NEW_PASSWORD_REQUIRED,
  NEW_PASSWORD_SESSION_ID,
} from "./actionTypes";

const initialState = {
  error: "",
  loading: false,
  isNewpasswordRequired:false,
  newpasswordSessionId:""
};

const login = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER:
      state = {
        ...state,
        loading: true,
      };
      break;
    case LOGIN_SUCCESS:
      state = {
        ...state,
        loading: false,
      };
      break;
      case NEW_PASSWORD_REQUIRED:
      state = {
        isNewpasswordRequired:action.payload,
      };
      break;
      case NEW_PASSWORD_SESSION_ID:
      state = {
        ...state,
        loading: false,
        newpasswordSessionId:action.payload,
      };
      break;
    case LOGOUT_USER:
      state = { ...state, isUserLogout: false };
      break;
    case LOGOUT_USER_SUCCESS:
      state = { ...state, isUserLogout: true };
      break;
    case API_ERROR:
      state = {
        ...state,
        error: action.payload,
        loading: false,
        isUserLogout: false,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default login;
